import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EditContext = createContext({
  isEditing: false,
  content: {},
  saveContent: () => {},
  uploadAndGetUrl: async () => "",
});

export function useEdit() {
  return useContext(EditContext);
}

export function EditProvider({ children }) {
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setIsEditing(params.get("edit") === "true");
  }, []);

  useEffect(() => {
    axios.get(`${API}/content`).then(res => setContent(res.data)).catch(() => {});
  }, []);

  const saveContent = useCallback(async (key, value) => {
    setContent(prev => ({ ...prev, [key]: value }));
    try {
      await axios.post(`${API}/content`, { key, value });
    } catch (e) {
      console.error("Save failed:", e);
    }
  }, []);

  const uploadAndGetUrl = useCallback(async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(`${API}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const storagePath = res.data.storage_path;
      return `${API}/files/${storagePath}`;
    } catch (e) {
      console.error("Upload failed:", e);
      return "";
    }
  }, []);

  return (
    <EditContext.Provider value={{ isEditing, content, saveContent, uploadAndGetUrl }}>
      {isEditing && (
        <div className="fixed top-0 left-0 right-0 z-[60] bg-w-sage text-white text-center py-1.5 font-body text-xs tracking-wider">
          Modalita' modifica attiva &middot; Clicca sui testi o sulle immagini per modificarli
        </div>
      )}
      {children}
    </EditContext.Provider>
  );
}
